export default __webpack_public_path__ + "static/media/planet-md.6efa3a57.svg";